import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { ColorService } from '@zaoblako/web/core/services/color.service';
import { DeepPartial } from '@zaoblako/web/core/types/deep-partial';
import { ApiUrlPipe } from '@zaoblako/web/shared/pipes/api-url.pipe';
import { AvatarModule } from 'primeng/avatar';
import * as uniqolor from 'uniqolor';

@Component({
  standalone: true,
  selector: 'crm-user-avatar',
  templateUrl: './user-avatar.component.html',
  imports: [CommonModule, AvatarModule, ApiUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent implements OnInit {
  @Input() public user: DeepPartial<UserFindInterface>;
  @Input() public size = 'large';
  @Input() public shape: 'circle' | 'square' = 'square';

  public backgroundColor: string;

  public get userLabel() {
    const [secondName, firstName] = (this.user?.name || this.user?.profile?.name || '').split(' ');
    return (secondName ? secondName[0] : '') + (firstName ? firstName[0] : '');
  }

  public constructor(public readonly colorService: ColorService) {}

  public ngOnInit() {
    this.backgroundColor = uniqolor(`${this.user?.name || this.user?.profile?.name}-${this.user?.id}`)?.color;
  }
}
